import { uniqueId, objectAssign } from "@/views/zhiji/js/common/util.js";
import { redPointType, hotNewType } from "@/views/zhiji/js/common/constants.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "HList",
    serverType: ["tip", "video", "image", "question"],
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "HList",
            containType: "",
            items: []
        };
    },
    initItem(item) {
        if (item.type == "tip") {
            return initStrategyItem(item);
        } else if (item.type == "video") {
            return initVideoItem(item);
        } else if (item.type == "question") {
            return initContainerItem(item);
        }

        return initImageItem(item);
    },
    checkContent(content) {
        if (!content.containType) {
            throw new ParamError(i18n.t("zhiji.answer.hListWidge.hListEmptyTips"));
        }

        content.items.forEach(function(item) {
            item.wtType == "StrategyItem" && checkStrategyItem(item);
            item.wtType == "VideoItem" && checkVideoItem(item);
            item.wtType == "ImageItem" && checkImageItem(item);
            item.wtType == "ContainerItem" && checkContainerItem(item);
        });
    },
    server2Client(content) {
        const itemCvts = {
            tip: cvt2ClientStrategyItem,
            video: cvt2ClientVideoItem,
            image: cvt2ClientImageItem,
            question: cvt2ClientContainerItem
        };
        let items = [];
        let servertype = "";
        servertype = content.container_content[0].element.type;

        items = content.container_content.map(function(serverItem) {
            return itemCvts[serverItem.element.type](serverItem, serverItem.element);
        });

        return {
            uId: uniqueId(),
            updateState: "",
            wtType: "HList",
            containType: servertype,
            items: items
        };
    },
    client2Server(content) {
        let items = content.items.filter(function(item) {
            return item.updateState != "delete";
        });

        const itemCvts = {
            StrategyItem: cvt2ServerStrategyItem,
            VideoItem: cvt2ServerVideoItem,
            ImageItem: cvt2ServerImageItem,
            ContainerItem: cvt2ServerContainerItem
        };
        items = content.items.map(function(item, idx) {
            return {
                id: Number(idx),
                title: item.name,
                desc: item.name,
                image: item.cardImage,
                red_switch: item.redState == "off" ? redPointType.OFF : redPointType.ON,
                hot_switch: item.hotItem == "NEW" ? hotNewType.NEW : hotNewType.HOT,
                hot_new_end_time: item.redHotEndTime,
                element: itemCvts[item.wtType](item)
            };
        });

        return {
            type: "container",
            container_type: "2",
            number: items.length,
            container_content: items
        };
    }
};

// 初始化视频Item
function initVideoItem(item) {
    return objectAssign(
        {
            wtType: "VideoItem",
            name: item.name || "",
            url: item.url || "",
            reference: "",
            videoSize: item.videoSize || "",
            videoTime: item.videoTime || "",
            videoId: item.videoId || ""
        },
        itemCommonField(item)
    );
}

// 初始化图片Item
function initImageItem(item) {
    return objectAssign(
        {
            wtType: "ImageItem",
            name: item.name || "",
            image: item.image || "",
            url: "",
            urlType: ""
        },
        itemCommonField(item)
    );
}

// 初始化攻略Item
function initStrategyItem(item) {
    return objectAssign(
        {
            wtType: "StrategyItem",
            content: "",
            name: item.name || "",
            url: item.url || "",
            resourceId: item.resourceId || "",
            contentFormat: item.contentFormat || "",
            reference: ""
        },
        itemCommonField(item)
    );
}

// 初始化容器Item
function initContainerItem(item) {
    return objectAssign(
        {
            wtType: "ContainerItem",
            name: "",
            content: "",
            questionId: ""
        },
        itemCommonField(item)
    );
}

// item的公共部分
function itemCommonField(item) {
    return {
        uId: uniqueId(),
        updateState: "add",
        redState: "off",
        hotItem: "NEW",
        redHotEndTime: "",
        resourceId: item.resourceId || "0",
        cardImage: item.cardImage || "",
        id: "" // 后台使用前台不能修改
    };
}

// check校验VideoItem
function checkVideoItem(item) {
    if (!item.name) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.videoItemEmptyTips"));
    }
    /* eslint-disable */
    const match = /^(https:)?\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/;
    if (!item.url || !match.test(item.url)) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.videoUrlErrorTips"));
    }

    if (!item.cardImage) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.videoCoverLoseTips"));
    }
}

// check校验ImageItem
function checkImageItem(item) {
    if (!item.name) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.imageDescEmptyTips"));
    }

    if (!item.image) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.notUploadImageTips"));
    }

    if (!item.cardImage || item.cardImage == "none") {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.notCoverTips"));
    }
}

// check校验StrategyItem
function checkStrategyItem(item) {
    if (!item.name) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.guidesDescEmptyTips"));
    }

    if (!item.resourceId) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.guidesNotEditTips"));
    }

    if (!item.cardImage) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.guidesNotCoverTips"));
    }
}

// check校验ContainerItem
function checkContainerItem(item) {
    if (!item.name) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.containerDescEmptyTips"));
    }

    if (!item.cardImage) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.containerNotCoverTips"));
    }

    if (!item.question) {
        throw new ParamError(i18n.t("zhiji.answer.hListWidge.containerNotLinkTips"));
    }
}

// 转换VideoItem到服务端格式
function cvt2ServerVideoItem(item) {
    return objectAssign(
        {
            type: "video",
            video_id: item.videoId,
            vt: item.videoTime + "",
            vsize: item.videoSize
        },
        cvt2ServerCommonItem(item)
    );
}

// 转换ImageItem到服务端格式
function cvt2ServerImageItem(item) {
    return objectAssign(cvt2ServerCommonItem(item), {
        type: "image",
        url_type: item.urlType,
        image: item.image,
        url: ""
    });
}

// 转换StrategyItem到服务端格式
function cvt2ServerStrategyItem(item) {
    return objectAssign(
        {
            type: "tip",
            content_type: "2",
            content: item.content,
            "content_format": item.contentFormat,
        },
        cvt2ServerCommonItem(item)
    );
}

// 转换ContainerItem到服务端格式
function cvt2ServerContainerItem(item) {
    return objectAssign(
        {
            type: "question",
            content: item.question,
            question_id: "" + item.questionId
        },
        cvt2ServerCommonItem(item)
    );
}

// 公共字段转换到服务端格式
function cvt2ServerCommonItem(item) {
    return {
        resource_id: String(item.resourceId) || "0",
        name: item.name,
        image: item.cardImage,
        url: item.url
    };
}

// 视频Item转换到客户端格式
function cvt2ClientVideoItem(item, element) {
    return objectAssign(
        {
            wtType: "VideoItem",
            videoId: element.video_id || "",
            videoTime: element.vt || "",
            videoSize: element.vsize || ""
        },
        cvt2ClientCommonField(item, element)
    );
}

// 图片Item转换到客户端格式
function cvt2ClientImageItem(item, element) {
    return objectAssign(
        {
            wtType: "ImageItem",
            image: element.image,
            urlType: element.url_type
        },
        cvt2ClientCommonField(item, element)
    );
}

// 攻略Item转换到客户端格式
function cvt2ClientStrategyItem(item, element) {
    return objectAssign(
        {
            wtType: "StrategyItem",
            content: element.content,
            contentType: element.container_type,
            contentFormat: element.content_format
        },
        cvt2ClientCommonField(item, element)
    );
}

// 容器Item转换到客户端格式
function cvt2ClientContainerItem(item, element) {
    return objectAssign(
        {
            wtType: "ContainerItem",
            question: element.content,
            questionId: element.question_id
        },
        cvt2ClientCommonField(item, element)
    );
}

// 公共字段转换到客户端格式
function cvt2ClientCommonField(item, element) {
    return {
        uId: uniqueId(),
        updateState: "add",
        name: element.name || item.desc,
        url: element.url || "",
        resourceId: "" + element.resource_id,
        cardImage: element.card_image || item.image,
        id: item.id || "",
        redState: redPointType.OFF == item.red_switch ? "off" : "on",
        hotItem: hotNewType.NEW == item.hot_switch ? "NEW" : "HOT",
        redHotEndTime: item.hot_new_end_time || ""
    };
}
